import { Card, CardBody, Col } from "reactstrap";
import { Image } from "../../../../AbstractElements";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { DisabledList, Href } from "../../../../Constant";
import { DISABLE_LIST, DISABLE_LIST_DATA } from "../../../../Data/UiKit/Lists";
import { dynamicImage } from "../../../../Service/DynamicImage";

const DisabledLists = () => {
  return (
    <Col xxl="4" md="6">
      <Card>
        <CommonCardHeader title={DisabledList} span={DISABLE_LIST_DATA} />
        <CardBody>
          <div className="list-group">
            <a className="list-group-item list-group-item-action bg-light-hover-primary active" href={Href}><Image className="rounded-circle mx-2" src={dynamicImage("user/5.jpg")} alt="user" />Teresa J. Mosteller</a>
            {DISABLE_LIST.map(({ text, className,src }, index) => (
              <a className={`list-group-item list-group-item-action ${className ? className : ""}`} key={index} href={Href}>
                <Image className="rounded-circle mx-2" src={src} alt="user" />{text}</a>
            ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default DisabledLists;
